import React from 'react';
import H1 from 'apps/Pdf/components/common/H1';
import P from 'apps/Pdf/components/common/P';
import useGeneralStyles from 'apps/Pdf/styles/general';

interface Props {
  protocol: boolean;
}

const Signature = (props: Props) => {
  const styles = useGeneralStyles();
  return props.protocol ? (
    <>
      <H1>Podpis zákazníka</H1>
      <P>
        <span className={styles.bold}>Dokument je podepsán elektronicky.</span>
        {props.protocol && (
          <>
            <br />
            Poslední stránka dokumentu obsahuje protokol o elektronickém potvrzení dokumentu.
          </>
        )}
      </P>
    </>
  ) : null;
};

export default Signature;
